import * as React from 'react';
import * as styles from './SubAgentLimitExceed.css';

export const SubAgentLimitExceed = () => {
  return (
    <div className={styles['wrapper']}>
      Закончился лимит публикаций, который&nbsp;установило ваше агентство. Обратитесь к&nbsp;своему менеджеру,
      чтобы&nbsp;снова публиковать объявления.
    </div>
  );
};
